<template>
  <div>
    <slot name="card-header"></slot>
    <slot name="header"></slot>

    <!-- Paper Editor (Editor.js 기반) -->
    <paper-editor
      ref="paperEditor"
      :value="content"
      :comments="localComments"
      @input="handleEditorChange"
      @change="handleEditorChange"
      @update-content="handleEditorChange"
      @update:comments="handleCommentsUpdate"
      :style="{ height: height + 'px' }"
    ></paper-editor>

    <slot name="bottom-content"></slot>
    <slot name="bottom-buttons"></slot>
  </div>
</template>

<script>
import PaperEditor from "@/components/editors/PaperEditor.vue";

export default {
  name: "submission-editor-card",
  components: {
    PaperEditor,
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 500,
    },
    comments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      content: this.value || "",
      localComments: [],
    };
  },
  methods: {
    handleEditorChange(newContent) {
      this.content = newContent || "";
      this.$emit("update-content", this.content);
      this.$emit("input", this.content);
    },
    handleCommentsUpdate(newComments) {
      this.localComments = newComments || [];
      this.$emit("update:comments", this.localComments);
    },

    // 외부에서 에디터 데이터 가져오기
    async getEditorData() {
      if (this.$refs.paperEditor) {
        return await this.$refs.paperEditor.getData();
      }
      return null;
    },

    // 외부에서 HTML 가져오기
    async getHtml() {
      if (this.$refs.paperEditor) {
        return await this.$refs.paperEditor.getHtml();
      }
      return this.content;
    },
  },
  watch: {
    value(newValue) {
      if (newValue !== this.content) {
        this.content = newValue || "";
      }
    },
    comments: {
      handler(newComments) {
        if (newComments && Array.isArray(newComments)) {
          this.localComments = [...newComments];
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
/* PaperEditor에 내장된 주석 UI를 사용 */
</style>
